import '.d{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ap{justify-content:center;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.cn{text-align:center;}.ssr-plugin'
import '.cu{margin:6rem auto 3rem;}.ssr-plugin'
import { styled } from 'inlines'
import { PageLayout } from '../layout/PageLayout'
import notFoundImage from '@app/assets/images/error/not-found.svg'
import { Image } from '@app/components/core/image/Image'
import { Title } from '@app/components/core/typography/Title'
import { Text } from '@app/components/core/typography/Text'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'

export const NotFoundPage = () => {
  const isMobile = useMediaQuery()
  const t = useTranslations().app.error
  const contentStyle = isMobile
    ? { minWidth: '17rem', gap: '1rem' }
    : { maxWidth: '40rem', gap: '2.5rem' }
  const imageStyle = { width: isMobile ?   '17rem' : 'auto' }
  const BodyText = isMobile ? Text.Medium : Text.Large

  return (
    <PageLayout>
      <div className="d e ap r cn cu"
      >
        <styled.div className="d e r"
          style={{
            ...contentStyle,
          }}
        >
          <Image src={notFoundImage} alt={t.imageAlt} style={imageStyle} />
          <Title.H2 style={{ marginBottom: 0 }}>{t.notFoundTitle}</Title.H2>
          <BodyText>{t.notFoundMessage}</BodyText>
        </styled.div>
      </div>
    </PageLayout>
  )
}
